import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { AnvandareService } from '../../anvandare.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AnvandarRoll, Role, RoleLabels } from '../../anvandare.models';
import { AnvandareOrganisation } from 'src/app/auth/services/auth.model';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-anvandare-organisation',
  standalone: false,
  templateUrl: './add-anvandare-organisation.component.html',
  styleUrl: './add-anvandare-organisation.component.scss',
})
export class AddAnvandareOrganisationComponent implements OnInit {
  private dialogRef = inject(DynamicDialogRef<AddAnvandareOrganisationComponent>);
  private anvandareService = inject(AnvandareService);
  private config = inject(DynamicDialogConfig);
  private destroy = inject(DestroyRef);
  private fb = inject(FormBuilder);


  anvandareOrganisation: AnvandareOrganisation = {
    organisationId: '',
    epost: '',
    organisation: '',
    telefon: '',
    titel: '',
  };


  orgForm = this.fb.nonNullable.group({
    epost: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]],
    organisation: [''],
    organisationId: [''],
    telefon: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    titel:[''],
    selectedOrg:['', [Validators.required]]
  });

  anvandarRoller: AnvandarRoll[] = [];

  protected organisations!: any;
  protected roles = [
    { roll: 'SR22', checked: false },
    { roll: 'SR25', checked: false },
    { roll: 'SR26', checked: false },
  ];


  ngOnInit(): void {
    this.orgForm = this.fb.nonNullable.group({
      epost: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]],
      organisation: [''],
      organisationId: [''],
      telefon: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      titel:[''],
      selectedOrg:['', [Validators.required]]
    });
    const anvandareOrgs = this.config.data.anvandare.anvandareOrganisationer.map((org: AnvandareOrganisation) => org.organisationId)
    this.anvandareService
      .getAllOrganisations()
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe((orgs) => {
        this.organisations = orgs
          .filter((org) => org.labKod?.includes('SE'))
          .filter(org => !anvandareOrgs.includes(org.id))
          .map((org) => {
            return {
              ...org,
              label: `${org.labKod} - ${org.namn}`,
            };
          })
          .sort((a, b) => (a.labKod < b.labKod ? -1 : 1));
      });
  }


  getRoleLabel(roll: string) {
    return RoleLabels[roll as Role] || roll; // Return the label or the original roll if not found
  }

  setOrg(org: any) {
    this.orgForm.patchValue({
      organisation: org.namn,
      organisationId: org.id
    })
  }

  save = () => {
    this.anvandarRoller = this.roles
      .filter((role) => role.checked)
      .map((x) => {
        return {
          organisationId: this.orgForm.controls.organisationId.value,
          roll: x.roll,
        };
      });

    this.dialogRef.close({ org: this.orgForm.value, roles: this.anvandarRoller });
  }

  cancel() {
    this.dialogRef.close();
  }
}
